import React from 'react'
import { Stack, Box } from '@mui/material'
import { useTranslation } from 'react-i18next'
import DeviceIcon from '../../../pages/Supervision/Body/Home/Card/DeviceIcon'
import { isRackType } from '../../../pages/Supervision/helpers'
import {
  PopupContainer,
  ParentHeader,
  ParentIcon,
  ParentLabel,
  VerticalLine,
  TreeContainer,
  ChildContainer,
  HorizontalBranch,
  CurvedBranch,
  ChildContent,
  ChildLabel,
} from './styles'

const ParentPopup = ({ device }) => {
  const { t } = useTranslation()
  const branchWidth = 10
  const branchHeight = 32
  const iconSpacing = 8
  const parentSpacing = 8
  const isRack = isRackType(device.model?.type)
  const hasChildren = device.children && device.children.length > 0

  const renderParentIcon = () => {
    if (isRack) {
      return <i className="fa-solid fa-grid-dividers" style={{ fontSize: '14px', color: 'white', fontWeight: 400 }} />
    } else {
      return <DeviceIcon type={device.model?.type} device={device} size={20} />
    }
  }
  
  return (
    <PopupContainer>
      <Stack spacing={1.5} sx={{ width: '100%', alignItems: 'flex-start' }}>
        <ParentHeader>
          {hasChildren && (
            <VerticalLine
              height={(device.children.length - 1) * branchHeight + 16}
              left={10}
              top={20 + parentSpacing}
            />
          )}
          <ParentIcon isRack={isRack}>
            {renderParentIcon()}
          </ParentIcon>
          <ParentLabel>{device.label}</ParentLabel>
        </ParentHeader>

        {hasChildren ? (
          <TreeContainer>
            <Stack spacing={0}>
              {device.children.map((child, idx) => {
                const isLast = idx === device.children.length - 1
                return (
                  <ChildContainer key={child.uuid} height={branchHeight}>
                    {!isLast && (
                      <HorizontalBranch
                        width={branchWidth}
                        left={10}
                        top="50%"
                      />
                    )}

                    {isLast && (
                      <CurvedBranch
                        width={branchWidth}
                        left={10}
                      />
                    )}

                    <ChildContent marginLeft={`${branchWidth + 10 + iconSpacing}px`}>
                      <DeviceIcon type={child.model?.type} device={child} size={20} />
                      <ChildLabel>{child.label}</ChildLabel>
                    </ChildContent>
                  </ChildContainer>
                )
              })}
            </Stack>
          </TreeContainer>
        ) : (
          <Box sx={{ 
            py: 1, 
            px: 2, 
            textAlign: 'center', 
            color: '#A2AAB8',
            fontSize: '12px',
            fontStyle: 'italic'
          }}>
            {t('supervision.popup.no_child_devices')}
          </Box>
        )}

      </Stack>
    </PopupContainer>
  )
}

export default ParentPopup